import { useState } from "react";
import { Users } from "lucide-react";

function MentorCard({ m, isMobile }) {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div
      className="mentor-card flex flex-col"
      onMouseEnter={() => setShowInfo(true)}
      onMouseLeave={() => setShowInfo(false)}
      onTouchStart={() => setShowInfo(v => !v)}
      style={{ cursor: "pointer" }}
    >
      {/* ── Photo box ── */}
      <div
        className="relative w-full overflow-hidden bg-gray-100"
        style={{
          borderRadius: "20px",
          aspectRatio: "3 / 4",
          boxShadow: showInfo
            ? "0 20px 60px rgba(30,58,138,0.28), 0 4px 16px rgba(0,0,0,0.10)"
            : "0 8px 32px rgba(30,58,138,0.13), 0 2px 8px rgba(0,0,0,0.07)",
          border: showInfo ? "2px solid #3b82f6" : "2px solid #e5e7eb",
          transform: showInfo ? "translateY(-6px) scale(1.02)" : "translateY(0) scale(1)",
          transition: "all 0.3s cubic-bezier(0.22,1,0.36,1)",
        }}
      >
        {m.photo ? (
          <img
            src={m.photo.src}
            alt={m.name}
            loading="lazy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: m.photo.pos,
              display: "block",
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
            <Users className="text-blue-300" style={{ width: 80, height: 80 }} />
          </div>
        )}

        {/* Hover overlay with bio + certs */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to top, rgba(8,16,50,0.97) 60%, rgba(8,16,50,0.55) 100%)",
            borderRadius: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            padding: isMobile ? "12px" : "16px",
            opacity: showInfo ? 1 : 0,
            transform: showInfo ? "translateY(0)" : "translateY(8px)",
            transition: "opacity 0.25s ease, transform 0.25s ease",
            pointerEvents: showInfo ? "auto" : "none",
            overflowY: "auto",
          }}
        >
          {m.bio && (
            <p style={{
              color: "#cbd5e1",
              fontSize: isMobile ? "9px" : "11px",
              lineHeight: 1.5,
              marginBottom: "8px",
            }}>{m.bio}</p>
          )}
          {m.certs && m.certs.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginBottom: "6px" }}>
              {m.certs.map((c, i) => (
                <span key={i} style={{
                  background: "rgba(30,58,138,0.7)",
                  border: "1px solid rgba(96,165,250,0.35)",
                  color: "#93c5fd",
                  fontSize: "8px",
                  padding: "2px 7px",
                  borderRadius: "999px",
                }}>🏆 {c}</span>
              ))}
            </div>
          )}
          {m.linkedin && (
            <a
              href={m.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#60a5fa", fontSize: "10px", textDecoration: "none" }}
            >
              <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 11, height: 11 }}>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              LinkedIn
            </a>
          )}
        </div>
      </div>

      {/* ── Info below photo ── */}
      <div style={{ paddingTop: "12px", paddingLeft: "4px", paddingRight: "4px", textAlign: "center" }}>
        <p style={{
          fontWeight: 800,
          color: "#0f172a",
          fontSize: isMobile ? "13px" : "15px",
          lineHeight: 1.3,
          marginBottom: "3px",
        }}>{m.name}</p>
        <p style={{
          fontWeight: 600,
          color: "#F08232",
          fontSize: isMobile ? "11px" : "13px",
          lineHeight: 1.3,
          marginBottom: "3px",
        }}>{m.role}</p>
        {m.workplace && (
          <p style={{
            color: "#64748b",
            fontSize: isMobile ? "10px" : "12px",
            lineHeight: 1.3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}>
            <span>🏢</span>{m.workplace}
          </p>
        )}
      </div>
    </div>
  );
}

export { MentorCard };
